'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
function isDesktop(screenSize) {
	var desktop = false;

	if (screenSize === 'lg' || screenSize === 'xl') {
		desktop = true;
	}

	return desktop;
}

exports.default = isDesktop;